import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, EventManager, JhiLanguageService } from 'ng-jhipster';

import { Invoice, InvoiceStatus } from './invoice.model';
import { InvoicePopupService } from './invoice-popup.service';
import { InvoiceService } from './invoice.service';
import { Principal, CRUD_ACTIONS } from '../../shared/index';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { School, SchoolService } from '../school';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-invoice-reverse-dialog',
    templateUrl: './invoice-reverse-dialog.component.html'
})
export class InvoiceReverseDialogComponent extends AbstractDialogComponent implements OnInit {

    invoice: Invoice;
    isSaving: boolean;
    authorities: any[];
    currentSchool: School;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private invoiceService: InvoiceService,
        public activeModal: NgbActiveModal,
        schoolService: SchoolService,
        alertService: AlertService,
        principal: Principal,
        private eventManager: EventManager
    ) {
        super(schoolService, alertService, principal);
        this.jhiLanguageService.setLocations(['payment', 'paymentItem', 'paymentType', 'invoice', 'invoiceStatus']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_SCHOOL-ADMIN', 'ROLE_ADMIN'];
        this.schoolService.findCurrent()
                              .subscribe(school => {
                                this.currentSchool = school;
                              }, e => this.onError(e));
    }

    clear() {
        this.isSaving = false;
        this.activeModal.dismiss('cancel');
    }

    isSaveEnabled() {
        if (!this.currentSchool || !this.currentSchool.startingInvoiceNumber) {
            return false;
        }

        return true;
    }

    confirmReverse(id: number) {
        if (id !== this.invoice.id) {
            this.activeModal.dismiss(true);
            return;
        }

        let reversedStatus: any = 'REVERSED';
        this.invoice.status = reversedStatus;

        this.invoiceService.update(this.invoice).subscribe(response => {
            this.onSaveSuccess(response, CRUD_ACTIONS.UPDATE);
            this.activeModal.dismiss(true);
        }, (res: HttpErrorResponse) => this.onSaveError(res));
    }

    private onSaveSuccess(result: Invoice, action: String) {
        this.eventManager.broadcast({ name: 'invoiceListModification', content: {
            action: action,
            content: result
        }});

        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }
}

@Component({
    selector: 'jhi-invoice-reverse-popup',
    template: ''
})
export class InvoiceReversePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private invoicePopupService: InvoicePopupService,
        private jhiLanguageService: JhiLanguageService,
    ) {

    }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.invoicePopupService
                .open(InvoiceReverseDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/invoice/invoice-reverse-dialog.component.ts